module.exports = __webpack_public_path__ + "static/media/lindsey.b0fbc301.jpeg";